module.exports = __webpack_public_path__ + "static/img/Yudhistira Nugraha-close.d00bcff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profile/closeup/Yudhistira Nugraha-close.jpg
// module id = zcYF
// module chunks = 1